import React, { useEffect, useState } from "react";

import "./css/dashboard-layout.scss";
import "../../assets/css/dashboard.scss";

import AppBar from "./AppBar";
import Footer from "./Footer";
import BodyDiv from "./BodyDiv";
import Sidebar from "./Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import RoutingPaths from "../../utils/RoutingPaths";
import Welcome from "../../modals/dashboard/Welcome";
import { ROLE_FRONT_DESK_ADMIN } from "../../utils/Constants";

function DashboardLayout(props) {
  const navigate = useNavigate();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const userRole = JSON.parse(sessionStorage.getItem("UserRole"));
  const [isAppointmentModal, setIsAppointmentModal] = useState(false);
  const [profileData, setProfileData] = useState({});

  const organizationDto = JSON.parse(
    window.sessionStorage.getItem("OrgDetails2"),
  );

  const [addressData] = useState(
    organizationDto?.address || [],
  );
  const consultant = JSON.parse(sessionStorage.getItem("ConsultantDetails"));
  const [consultantAddressData] = useState(
    consultant?.addressesForConsultant || [],
  );

  const isConsultantUser = consultant !== null;

  const client = JSON.parse(sessionStorage.getItem("ClientDetails"));
  const isClientUser = client !== null;

  useEffect(() => {
    if (window.sessionStorage.getItem("token") === null) {
      navigate(RoutingPaths.LOGIN);
    }
  });

  useEffect(() => {
    let data = null;
    try {
      if (isConsultantUser) {
        const val = sessionStorage.getItem("ConsultantDetails");
        data = val ? JSON.parse(val) : null;
      } else if (isClientUser) {
        const val = sessionStorage.getItem("ClientDetails");
        data = val ? JSON.parse(val) : null;
      } else {
        const val = sessionStorage.getItem("OrgDetails");
        data = val ? JSON.parse(val) : null;
      }
    } catch (e) {
      data = null;
    }

    setProfileData(data);
  }, [isConsultantUser, isClientUser]);

  useEffect(() => {
    const address = organizationDto?.address;
    if (address?.length === 0 && userRole !== ROLE_FRONT_DESK_ADMIN) {
      toggleWelcomeModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionStorage.getItem("OrgDetails2")]);

  function toggleSidebar() {
    setIsSidebarOpen((isSidebarOpen) => !isSidebarOpen);
  }

  function toggleWelcomeModal() {
    setIsAppointmentModal(!isAppointmentModal);
  }

  useEffect(() => {
    const handleLoggedInUserDetailsUpdate = () => {
      const updatedLoggedInUserDetails = JSON.parse(
        sessionStorage.getItem("OrgDetails"),
      );
      setProfileData(updatedLoggedInUserDetails);
    };

    window.addEventListener(
      "loggedInUserDetailsUpdated",
      handleLoggedInUserDetailsUpdate,
    );

    return () => {
      window.removeEventListener(
        "loggedInUserDetailsUpdated",
        handleLoggedInUserDetailsUpdate,
      );
    };
    // eslint-disable-next-line
  }, []);

   useEffect(() => {
    if (isConsultantUser) {
      const handleLoggedInConsultantUserDetailsUpdate = () => {
      const updatedLoggedInConsultantUserDetails = JSON.parse(
        sessionStorage.getItem("ConsultantDetails"),
      );
      setProfileData(updatedLoggedInConsultantUserDetails);
    };

    window.addEventListener(
      "loggedInConsultantUserDetailsUpdated",
      handleLoggedInConsultantUserDetailsUpdate,
    );

    return () => {
      window.removeEventListener(
        "loggedInConsultantUserDetailsUpdated",
        handleLoggedInConsultantUserDetailsUpdate,
      );
    };
    }
  }, [isConsultantUser]);

  return (
    <section className="layoutX">
      <AppBar
        toggleSidebar={toggleSidebar}
        profileData={profileData}
        address={
          consultantAddressData?.length > 0
            ? consultantAddressData
            : addressData
        }
      />

      <section className="wrapperX">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          profileData={organizationDto}
        />
        <section className="content-wrapperX">
          <BodyDiv>
            <Outlet />
          </BodyDiv>
          <Footer />
        </section>
      </section>

      <Welcome show={isAppointmentModal} onHide={toggleWelcomeModal} />
    </section>
  );
}

export default DashboardLayout;
